<template>
  <div
    v-if="incoherences.length"
    class="alert alert-warning d-flex align-items-center mb-3 mt-2 d-print-none"
    role="alert"
  >
    <i class="fas fa-exclamation-triangle fa-2x me-3"></i>
    <div class="flex-grow-1">
      <h5 class="alert-heading mb-1">
        <strong>{{ $t("shippingIncoherenceTitle") }}</strong>
      </h5>
      <ul class="mb-0 ps-3">
        <li v-for="incoherence in incoherences" :key="incoherence.code">
          {{ incoherence.message }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";

/**
 * Cartel de un embarque cuyos datos no cierran entre sí (encabezado contra líneas, embarques
 * contra su proforma). Solo avisa; qué tenants lo tienen lo decide el back.
 * Va fuera del contenido que se imprime o se manda por email.
 */
export default {
  name: "ShippingIncoherenceBanner",
  props: {
    modelName: { type: String, required: true },
    itemId: { type: String, default: "" },
    /** Cambia con cada guardado: vuelve a consultar. */
    reloadKey: { type: [String, Number], default: "" },
  },
  data() {
    return { incoherences: [] };
  },
  computed: {
    isShipping() {
      return String(this.modelName || "").toLowerCase() === "shipping";
    },
  },
  watch: {
    itemId: "load",
    reloadKey: "load",
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      if (!this.isShipping || !this.itemId) {
        this.incoherences = [];
        return;
      }
      try {
        const { data } = await wencesApi.get(
          `/api/gotrading/shipping/${encodeURIComponent(this.itemId)}/incoherences`
        );
        this.incoherences = Array.isArray(data && data.incoherences) ? data.incoherences : [];
      } catch (error) {
        // Es un aviso: si la consulta falla, la vista sigue igual.
        console.error("ShippingIncoherenceBanner:", error);
        this.incoherences = [];
      }
    },
  },
};
</script>
